<crm-auto-complete
  #clientAutoComplete
  [(value)]="selectedClient"
  (valueChange)="selectedClientChange.emit($event)"
  [styleClass]="styleClass"
  [class]="class"
  [disabled]="disabled"
  [inputStyle]="inputStyle"
  [suggestions]="clients"
  [virtualScroll]="false"
  [filtersUiVersion]="filtersUiVersion"
  [inputStyleClass]="inputStyleClass"
  [appendTo]="appendTo"
  [placeholder]="placeholder"
  [isError]="isError"
  [showClear]="showClear"
  [loading]="loading || selectionLoading"
  (completeMethod)="customSearch ? clientSearch.emit($event.query) : searchClient($event.query)">
  <ng-template
    let-item="item"
    #itemTemplate>
    <span
      *ngIf="toClient(item) as client"
      class="block w-full min-w-0"
      [innerHTML]="highlightMatchText(client.name) | safeHtml"></span>
  </ng-template>
</crm-auto-complete>
